import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, List, Typography } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function HighChargebackRate() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const highChargebackRateNotifications = (notifications || []).find(
    n => n.type === ENotificationType.HIGH_CHARGEBACK_RATE
  );
  if (!highChargebackRateNotifications?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.HIGH_CHARGEBACK_RATE}`}>
      <List.Item extra={<Badge count={highChargebackRateNotifications?.quantity || 0} showZero />}>
        <Typography.Text strong>Alto índice de chargeback</Typography.Text>
      </List.Item>
    </Link>
  );
}
